import React, { useState } from 'react';
import { getLoggedInUser } from "../../../../helpers/authUtils";
import IconSearch from '../../../../assets/svg/ic-actions-search.svg';
import IconLink from '../../../../assets/svg/ic-actions-new-window.svg';
import IconImpressora from '../../../../assets/svg/print.svg';
import { openAtestado } from '../../../../Libs/Docs.js';
import ModalEnvio from '../../../../gb-components/ModalEnvio';

const CardAtestado = ({ interacao, idAtestado, paciente, profissional, DataAtendimento, DataCriacao, Hora, Dia, OpenModal }) => {

  const [profNome, setProfNome] = useState('');
  const [isVisibleSend, setIsVisibleSend] = useState(false);

  const sending = false;

  const renderBody = () => {
    return (
      <div>
        {profissional ? (<p><strong>Profissional: </strong>{profissional}</p>) : null}
        {DataAtendimento ? (
          <p>
            <strong>Data e Hora do Atendimento:</strong> {DataAtendimento}
            {/* {HoraAtendimento ? HoraAtendimento : ""} */}
          </p>
        ) : null}
        {Dia ? (<p><strong>Dias de Atestado:</strong> {Dia}</p>) : null}
      </div>
    )
  }


  return (
    <>
      <div className={"gb-card mb-3"}>
        <div className={getLoggedInUser().username === profissional ? "gb-card-header profissional" : "gb-card-header"}>
          <p>{profissional ? profissional : profNome}{" "}{/* {Concluida ? (<p>{Concluida}</p>) : null} */}</p>
          {DataCriacao ? (
            <span className="gb-card-header-hora">
              {" "}{DataCriacao.replace("-", "/").replace("-", "/")}{" "}{Hora ? Hora : ""}
            </span>
          ) : null}
          <div style={{ textAlign: getLoggedInUser().username === profissional ? 'left' : 'right' }}>

            <a href="#" onClick={OpenModal}>
              <img src={IconSearch} style={{ marginLeft: 15 }} />
            </a>

            <a href="#" onClick={() => {
              openAtestado(paciente.id, idAtestado);

            }}>
              <img src={IconImpressora} style={{ marginLeft: 15 }} />
            </a>

            {/* {this.state.sending ? (<div><PreLoaderWidget ></PreLoaderWidget></div>) : ()} */}
            <a href="#" onClick={() => setIsVisibleSend(true)}>
              <img src={IconLink} style={{ marginLeft: 15 }} />
            </a>

          </div>

        </div>

        <div className="gb-card-body">
          {renderBody()}
        </div>

      </div>

      {(idAtestado) ? <ModalEnvio visible={isVisibleSend}
        close={() => setIsVisibleSend(false)}
        pacienteId={paciente.id}
        card={'atestado'}
        docId={idAtestado}
        email={paciente.paciente.email}
        telefone={paciente.paciente.whatsapp ? paciente.paciente.whatsapp : paciente.paciente.telefones} /> : null}
    </>
  )
}

export default CardAtestado;